import styled from "styled-components";
import { Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/core-labels";
import { formatCurrency } from "../utils/format";
import { FeeGridRow } from "../styles/FeeManager.styles";

const TotalContainer = styled(FeeGridRow)<{ disabled?: boolean }>`
  margin-top: 20px;
  padding: 14px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;
`;

const LabelCell = styled.div`
  text-align: left;
`;

// Left-aligned to sit under the amount inputs, which carry a leading "$"
// adornment and so cannot read as right-aligned.
const AmountCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const EmptyCell = styled.div``;

export interface TotalFeesDisplayProps {
  total: number;
  vehicleType: "NEW" | "USED";
  disabled?: boolean;
  locale?: string;
}

export const TotalFeesDisplay = ({
  total,
  vehicleType,
  disabled,
  locale = "en-US"
}: TotalFeesDisplayProps) => {
  const typeLabel = Locale.getText(
    vehicleType === "NEW"
      ? "FEEMANAGER_NEW_TOTALFEES"
      : "FEEMANAGER_USED_TOTALFEES"
  );

  return (
    <TotalContainer disabled={disabled}>
      {/* Label in name column */}
      <LabelCell>
        <Typography variant={"body-sm"}>{typeLabel}</Typography>
      </LabelCell>

      {/* Total amount in amount column */}
      <AmountCell>
        <Typography variant={"h3"}>{formatCurrency(total, locale)}</Typography>
      </AmountCell>

      {/* Empty cell for action column */}
      <EmptyCell />
    </TotalContainer>
  );
};
